/*
 * @Author: tanyaohua
 * @Date: 2020-01-09 22:46:32
 * @Description: 读报评报功能
 */

'use strict';
angular.module('newspaperRemarkModule', [
    'newspaperRemarkListModule', // 列表页控制器
    'newspaperRemarkLeftModule', // 左侧导航控制器
    'newspaperRemarkDetailModule', // 详情页控制器
    'newsPaperInfoModel', // 评论详情弹框
    'newspaperRemarkChannelModule', // 评报栏模块
]);
